import { render, staticRenderFns } from "./SidebarLastViewed.vue?vue&type=template&id=703abc2b&scoped=true"
import script from "./SidebarLastViewed.vue?vue&type=script&lang=js"
export * from "./SidebarLastViewed.vue?vue&type=script&lang=js"
import style0 from "./SidebarLastViewed.vue?vue&type=style&index=0&id=703abc2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703abc2b",
  null
  
)

export default component.exports